import { router } from '@inertiajs/vue3';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAuthenticatorStore = defineStore('sw-authenticator', () => {
  const integrating = ref(false);
  const integrate = (
    target: 'goteam',
    redirect?: string,
    remember?: boolean,
  ) => {
    if (target === 'goteam') {
      integrating.value = true;
      router.visit('/goteam/login', { data: { redirect, remember } });
    }
  };

  return {
    integrate,
    integrating,
  };
});
